import { default as AlertMui } from "@mui/material/Alert";
import { AlertColor } from "@mui/material/Alert";
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import "./alert.scss";

import type { JSX } from "react";

const iconMap: Record<AlertColor, JSX.Element> = {
  info: <InfoIcon fontSize="inherit" />,
  success: <CheckCircleIcon fontSize="inherit" />,
  warning: <ErrorIcon fontSize="inherit" />,
  error: <ErrorIcon fontSize="inherit" />,
};

const Alert: React.FC<{ 
  severity: AlertColor; 
  message?: string;
  children?: React.ReactNode;
  dangerouslySetInnerHTML?: { __html: string };
  onClose?: () => void;
  className?: string;
}> = ({
  severity,
  message,
  children,
  dangerouslySetInnerHTML,
  onClose,
  className,
}) => {
  return (
    <div>
      <AlertMui
        variant="filled"
        severity={severity}
        icon={iconMap[severity]}
        className={`alert ${severity} ${className ? className : ""}`}
        onClose={onClose}
      >
        {children || (dangerouslySetInnerHTML ? (
          <span dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
        ) : (
          message
        ))}
      </AlertMui>
    </div>
  );
};

export default Alert;
